<template>
    <!-- 专家详情页面 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper workM">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>专家库</BreadcrumbItem>
                    <BreadcrumbItem>专家详情</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    专家详情 ： {{expertName}}
                </div>
                <div class="ruleM">
                    <h1 class="username">{{expertName}}</h1>
                    <img class="userimg" :src="picture" alt="">
                    <div class="userinfo" v-html="intro"></div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "Expert",
        data(){
            return {
              expertName:'',
              picture:'',
              intro:''
            }
        },
        mounted(){
          this.getExpert();
          this.setTab();
        },
        methods: {
            getExpert(){
                var that = this;
                this.$http({
                    url: that.webhost + 'expert/detail/'+that.$route.params.expertid,
                    method: 'GET',
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.expertName = data.data.expertName;
                        that.picture = data.data.picture;
                        that.intro = data.data.intro;
                    } else {
                        that.$Message.error(data.msg);
                    }
                }).catch(function (error) {
                   console.log(error);
                })
            },
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .ruleM .username {
        margin-top: 20px;
    }
    .ruleM .userimg {
      margin: 10px 0 ;
        width: 170px;
        height: 238px;
    }
    .ruleM .userinfo{
        width: 800px;
        margin: 10px auto;
        font-size: 18px;
        font-family: '微软雅黑',Verdana, Geneva, sans-serif;
        color: #666;
     }
</style>



// WEBPACK FOOTER //
// src/views/Expert.vue